// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"01eb1f8a32d0f744d7f9","993":"3f91b82db92eb776a3a6"}[chunkId] + ".js");